import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { initUpdateManager, subscribeUpdate, getUpdateSnapshot, retryStuckReload, type UpdateState } from '../../services/updateManager';
import './UpdateController.css';

// Monta el gestor de actualizaciones y muestra un toast efímero cuando
// el reload está en marcha. No expone botón "actualizar ahora" porque
// el flujo es silencioso: el toast es solo para que el usuario entienda
// el reload que viene a continuación y no lo perciba como un crash.
export function UpdateController() {
  const { t } = useTranslation();
  const [state, setState] = useState<UpdateState>(getUpdateSnapshot());

  useEffect(() => {
    initUpdateManager();
    const unsub = subscribeUpdate(setState);
    return unsub;
  }, []);

  // La recarga final no ocurrió (iOS): mensaje honesto y salida, en vez de
  // un spinner eterno.
  if (state.status === 'stuck') {
    return (
      <div className="update-toast update-toast--stuck" role="alert">
        <span>{t('components.updateStuck')}</span>
        <button type="button" className="update-toast__retry" onClick={retryStuckReload}>
          {t('components.updateRetry')}
        </button>
      </div>
    );
  }

  if (state.status !== 'applying') return null;

  return (
    <div className="update-toast" role="status" aria-live="polite">
      <div className="update-toast__spinner" />
      <span>{t('components.updating')}</span>
    </div>
  );
}
